export const trans_10_1=[
  {
    id:1,
    english:'She is very funny',
    vietnamese:'Cô ấy rất vui vẻ',
    user_message:''
  },
  {
    id:2,
    english:'I just came back to school after the holidays',
    vietnamese:'Tôi vừa mới quay lại trường học sau kỳ nghỉ',
    user_message:''
  },
  {
    id:3,
    english:'Yeasterday, we had a trip in Lai Chau',
    vietnamese:'Hôm qua, chúng tôi có chuyến đi lên Lai Châu',
    user_message:''
  },
  {
    id:4,
    english:'What do you think about this dress? It is beatiful',
    vietnamese:'Bạn nghĩ sao về chiếc váy này? Nó đẹp đấy',
    user_message:''
  }, 

]

export const trans_10_2=[
  {
    id:1,
    english:'Is he a teacher? Yes, he is a teacher',
    vietnamese:'Anh ấy có phải là giáo viên không? Đúng rồi, anh ấy là giáo viên',
    user_message:''
  },
  {
    id:2,
    english:'Is this the meeting room? No, this is accountant room',
    vietnamese:'Có phải đây là phòng họp không? Không phải, đây là phòng kế toán',
    user_message:''
  },
  {
    id:3,
    english:'What is the weatcher like Vinh? Today, the weatcher is very beatiful',
    vietnamese:'Hôm nay, thời tiết ở Vịnh như thế nào? Hôm nay thời tiết rất đẹp',
    user_message:''
  },
  {
    id:4,
    english:'How do you feel about spring roll of Vietnam? It is delicious',
    vietnamese:'Bạn thấy món Nem rán ở Việt Nam như thế nào? Nó rất ngon',
    user_message:''
  }, 
  {
    id:5,
    english:'What is the shape of Vietnams map? it is S-shaped',
    vietnamese:'Bán độ của Việt Nam hình gì? Nó hình chữ',
    user_message:''
  },  

]